import Modal from "components/CustomModal";
import Button from "components/Button";
import { getLocaleString } from "utils/localization/locale";

export default function ConfigureFTPFetch(props) {
  const {
    show,
    onClose,
    formData,
    updateFTPFetchSettings,
    submitFTPFetchSettings,
    triggerFTPFetchForRemittance,
    deleteFTPConfigForRemittance,
  } = props;

  return (
    <Modal
      size="md"
      show={show}
      onHide={() => onClose(false)}
      title={getLocaleString(
        "cash_application.configure_ftp_fetch",
        "Configure FTP Fetch"
      )}
      footer={() => (
        <>
          {formData.id ? (
            <>
              <Button
                variant="textual-secondary"
                onClick={() => triggerFTPFetchForRemittance(formData.id)}
              >
                {getLocaleString("common.fetch_now", "Fetch Now")}
              </Button>
              <Button
                variant="textual-danger"
                onClick={() => deleteFTPConfigForRemittance(formData.id)}
              >
                {getLocaleString("common.delete", "Delete")}
              </Button>
            </>
          ) : null}
          <Button
            variant="outline-primary"
            onClick={() => {
              onClose(false);
            }}
          >
            {getLocaleString("common.cancel", "Cancel")}
          </Button>
          <Button onClick={submitFTPFetchSettings}>
            {getLocaleString("common.submit", "Submit")}
          </Button>
        </>
      )}
    >
      <div className="row">
        <div className="col-12">
          {getLocaleString("cash_application.remote_url", "Remote URL")}
          <input
            type="text"
            className="form-control"
            value={formData.remote_path || ""}
            onChange={(e) =>
              updateFTPFetchSettings("remote_path", e.target.value)
            }
          />
        </div>
        <div className="col-12 mt-3">
          {getLocaleString("cash_application.ftp_username", "FTP Username")}
          <input
            type="text"
            className="form-control"
            value={formData.username || ""}
            onChange={(e) => updateFTPFetchSettings("username", e.target.value)}
          />
        </div>
        <div className="col-12 mt-3">
          {getLocaleString("cash_application.ftp_password", "FTP Password")}
          <input
            type="password"
            className="form-control"
            value={formData.password || ""}
            onChange={(e) => updateFTPFetchSettings("password", e.target.value)}
          />
        </div>
        <div className="col-12 mt-3">
          {getLocaleString("cash_application.ssh_key", "SSH Private Key")}
          <textarea
            className="form-control"
            rows={4}
            style={{ whiteSpace: "pre" }}
            value={formData.ssh_private_key || ""}
            onChange={(e) =>
              updateFTPFetchSettings("ssh_private_key", e.target.value)
            }
          />
        </div>
        <div className="col-12 mt-3">
          <input
            type="checkbox"
            className="md-checkbox me-2 align-top"
            defaultChecked={formData.is_active || ""}
            onChange={(e) =>
              updateFTPFetchSettings("is_active", e.target.checked)
            }
          />
          {getLocaleString("cash_application.is_active", "Is Active")}
        </div>
      </div>
    </Modal>
  );
}
